module.exports = "/_next/static/images/icon_store-c484b419c7b1bb4e98ffc5406785aadf.svg";